import { observer } from 'mobx-react-lite';

import GridContainer from '../components/container/GridContainer';

import Documents from '../views/documents/Documents';

const UnreadDocumentsPage = observer(
  (): JSX.Element => (
    <GridContainer>
      <Documents initialyShowDocs onlyUnreadDocs title="Ungelesene Dokumente" />
    </GridContainer>
  ),
);

export default UnreadDocumentsPage;
